import { render, staticRenderFns } from "./verEvento.vue?vue&type=template&id=79f9eec7&scoped=true"
import script from "./verEvento.vue?vue&type=script&lang=js"
export * from "./verEvento.vue?vue&type=script&lang=js"
import style0 from "./verEvento.vue?vue&type=style&index=0&id=79f9eec7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f9eec7",
  null
  
)

export default component.exports